<template>
  <div class="checkout-overlay-body">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'checkout-overlay-body'
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay-body {
    min-height: 100px;
    position: relative;

    .checkout-overlay-body-content {
      width: 100%;
    }

    .platform & {
      padding: 20px;
    }
  }
</style>
